import { useEffect } from "react"

export function CursorSpotlight({ enabled }: { enabled: boolean }) {
  useEffect(() => {
    if (!enabled || window.matchMedia("(pointer: coarse)").matches) return
    const root = document.documentElement
    const move = (event: PointerEvent) => {
      root.style.setProperty("--mx", `${event.clientX}px`)
      root.style.setProperty("--my", `${event.clientY}px`)
    }
    window.addEventListener("pointermove", move, { passive: true })
    return () => window.removeEventListener("pointermove", move)
  }, [enabled])

  return <div id="spotlight" aria-hidden="true" />
}
